import {createSlice} from '@reduxjs/toolkit';

const inspectionFormSlice = createSlice({
  name: 'inspectionForm',
  initialState: {
    // inspection item cache
    inspectionItems: [],
    activeInspectionItems: [],
    // states used to manage display transitions
    inspectionSelectedVehicle: {},
    inspectionSelectedImplement: {},
    activeImplementInspectionItems: [],
    inspectionFormSubmitted: false,
    // state to cache the user entered data
    inspectionReport: {},
    implementInspectionReport: {},
    // state to cache any scanned vehicle
    scannedVehicle: '',
    inspectionNameInput: '',
    inspectedByOperator: '',
    storeInspectionItems: [],
    storeImplementInspectionItems: [],
    vehicles: [],
    implements: [],
    databaseUsers: [],
    databaseUsersLoading: false,
  },
  reducers: {
    updateInspectionItems(state, action) {
      const inspectionItems = action.payload;

      // Filter out any archived inspectionItems as they are not needed
      const activeInspectionItems = inspectionItems.filter((inspectionItemDoc) => {
        return typeof inspectionItemDoc.archived !== 'undefined' && !inspectionItemDoc.archived;
      });

      // Set the arrays into the states
      state.inspectionItems = inspectionItems;
      state.activeInspectionItems = activeInspectionItems;
    },
    setInspectionSelectedVehicle(state, action) {
      state.inspectionSelectedVehicle = action.payload;
    },
    setInspectionSelectedImplement(state, action) {
      state.inspectionSelectedImplement = action.payload;
    },
    setInspectionScannedVehicle(state, action) {
      state.scannedVehicle = action.payload;
    },
    setInspectionFormSubmitted(state, action) {
      state.inspectionFormSubmitted = action.payload;
    },
    setInspectionReport(state, action) {
      state.inspectionReport = action.payload;
    },
    setImplementInspectionReport(state, action) {
      state.implementInspectionReport = action.payload;
    },
    setInspectionNameInput(state, action) {
      state.inspectionNameInput = action.payload;
    },
    setInspectedByOperator(state, action) {
      state.inspectedByOperator = action.payload;
    },
    resetInspectionInspectorFields(state) {
      state.inspectionNameInput = '';
      state.inspectedByOperator = '';
    },
    setStoreInspectionItems(state, action) {
      state.storeInspectionItems = action.payload;
    },
    setStoreImplementInspectionItems(state, action) {
      state.storeImplementInspectionItems = action.payload;
    },
    updateVehicles(state, action) {
      state.vehicles = action.payload;
    },
    updateImplements(state, action) {
      state.implements = action.payload;
    },
    setDatabaseUsers(state, action) {
      state.databaseUsers = action.payload;
    },
    setDatabaseUsersLoading(state, action) {
      state.databaseUsersLoading = action.payload;
    },
  },
});

export const {
  updateInspectionItems,
  setInspectionSelectedVehicle,
  setInspectionSelectedImplement,
  setInspectionScannedVehicle,
  setInspectionFormSubmitted,
  setInspectionReport,
  setImplementInspectionReport,
  setInspectionNameInput,
  setInspectedByOperator,
  resetInspectionInspectorFields,
  setStoreInspectionItems,
  setStoreImplementInspectionItems,
  updateVehicles,
  updateVehicleLabels,
  updateImplements,
} = inspectionFormSlice.actions;

function loadInspectionOperators() {
  return async (dispatch) => {
    dispatch(inspectionFormSlice.actions.setDatabaseUsersLoading(true));
    try {
      const response = await fetch('/settings/getOperators', {cache: 'no-store'});
      const payload = await response.json();
      const operators = Array.isArray(payload?.operators)
        ? payload.operators
            .filter((operator) => {
              return !operator.archived;
            })
            .map((operator) => {
              return {
                uid: operator.uid,
                name: operator.name || '',
              };
            })
            .sort((a, b) => {
              return String(a.name).localeCompare(String(b.name));
            })
        : [];
      dispatch(inspectionFormSlice.actions.setDatabaseUsers(operators));
    } catch {
      dispatch(inspectionFormSlice.actions.setDatabaseUsers([]));
    } finally {
      dispatch(inspectionFormSlice.actions.setDatabaseUsersLoading(false));
    }
  };
}

export {loadInspectionOperators};
export default inspectionFormSlice.reducer;
